// Asegúrate de que ModalSucursales esté importado correctamente.
// Aquí está el código para el modal actualizado:

import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function ModalSucursales({ title, onClose, onConfirm, items,usuario, password }) {
    const [selectedSucursal, setSelectedSucursal] = useState(null);

    const handleChange = (event) => {
        setSelectedSucursal(event.target.value);
    };
console.log(items);
    const handleAccept = () => {
        if (selectedSucursal) {
            console.log(selectedSucursal);
            onConfirm(usuario, password,selectedSucursal);
            onClose();
        } else {
            alert("Por favor, seleccione una sucursal.");
        }
    };

    return (
        <Modal
            open={true}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    {title}
                </Typography>
                <FormControl fullWidth sx={{ mt: 2 }}>
                    <InputLabel id="select-sucursal-label">Sucursal</InputLabel>
                    <Select
                        labelId="select-sucursal-label"
                        value={selectedSucursal || ''}
                        label="Sucursal"
                        onChange={handleChange}
                    >
                        <MenuItem value="">
                            <em>Seleccione una sucursal</em>
                        </MenuItem>
                        {
                        items.map(item => (
                            <MenuItem key={item.idSucursal} value={item}>
                                {item.nombreSucursal}
                            </MenuItem>
                        ))
                        }
                    </Select>
                </FormControl>
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
                    <Button variant="contained" onClick={handleAccept}>Aceptar</Button>
                    <Button variant="outlined" onClick={onClose}>Cerrar</Button>
                </Box>
            </Box>
        </Modal>
    );
}

export default ModalSucursales;
